import { getCards, updateLinker } from '@vlabs/api/artemy/client';

const PAGE_SIZE = 1000;

async function fetchCardIds(listId: string, page: number): Promise<string[]> {
  const response = await getCards({
    page,
    page_size: PAGE_SIZE,
    list_ids: [listId],
    order: 'asc',
    sort: 'card_id',
    targets: ['card_id'],
  });

  return response.cards?.reduce<string[]>((acc, card) => {
    if (card.card_id) acc.push(card.card_id);
    return acc;
  }, []) ?? [];
}

export async function attachAllCardsFromList({
  sourceListId,
  targetListId,
}: {
  sourceListId: string;
  targetListId: string;
}): Promise<void> {
  let page = 1;
  let loadedCardsCount: number;

  do {
    const cardIds = await fetchCardIds(sourceListId, page);

    loadedCardsCount = cardIds.length;

    if (loadedCardsCount > 0) {
      await updateLinker({
        action: 'attach',
        card_ids: cardIds,
        list_id: targetListId,
      });
    }

    page += 1;
  } while (loadedCardsCount === PAGE_SIZE);
}
